import axios from 'axios'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'

const mimeMap = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
  txt: 'text/xml',
  pdf: 'application/pdf'
}

const baseUrl = process.env.VUE_APP_BASE_API
export function downLoadZip(str, filename, method, data) {
  return new Promise((resolve) => {
    var url = baseUrl + str
    if (!method || method === 'get') {
      axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        headers: { Authorization: getToken() }
      })
        .then((res) => {
          if (data) {
            if (data.exportType === '0' || !data.exportType) {
              resolveBlob(res, mimeMap.xlsx, filename)
            } else if (data.exportType === '1') {
              resolveBlob(res, mimeMap.txt, filename)
            } else if (data.exportType === '2') {
              resolveBlob(res, mimeMap.pdf, filename)
            }
          } else {
            resolveBlob(res, mimeMap.zip, filename)
          }
        })
        .catch((err) => {
          var reader = new FileReader()
          reader.onloadend = function (event) {
            // 获取解析后的结果
            var result = event.target.result
            Message({ message: JSON.parse(result).msg, type: 'error' })
          }
          reader.readAsText(err.response.data)
        })
        .finally(() => {
          resolve()
        })
    } else {
      axios({
        method: 'post',
        url: url,
        data: data,
        responseType: 'blob',
        headers: { Authorization: getToken() }
      })
        .then((res) => {
          if (data) {
            if (data.exportType === '0' || !data.exportType) {
              resolveBlob(res, mimeMap.xlsx, filename)
            }
          } else {
            resolveBlob(res, mimeMap.zip, filename)
          }
        })
        .catch((err) => {
          var reader = new FileReader()
          reader.onloadend = function (event) {
            // 获取解析后的结果
            var result = event.target.result
            Message({ message: JSON.parse(result).msg, type: 'error' })
          }
          reader.readAsText(err.response.data)
        })
        .finally(() => {
          resolve()
        })
    }
  })
}
// 下载固定路径文件
export function downLoadZipFixed(str, filename, method, data) {
  if (!method || method === 'get') {
    axios({
      method: 'get',
      url: str,
      responseType: 'blob',
      headers: { Authorization: getToken() }
    }).then((res) => {
      if (data) {
        if (data.exportType === '0' || !data.exportType) {
          resolveBlob(res, mimeMap.xlsx, filename)
        } else if (data.exportType === '1') {
          resolveBlob(res, mimeMap.txt, filename)
        }
      } else {
        resolveBlob(res, mimeMap.zip, filename)
      }
    })
  } else {
    axios({
      method: 'post',
      url: str,
      data: data,
      responseType: 'blob',
      headers: { Authorization: getToken() }
    }).then((res) => {
      if (data) {
        if (data.exportType === '0' || !data.exportType) {
          resolveBlob(res, mimeMap.xlsx, filename)
        }
      } else {
        resolveBlob(res, mimeMap.zip, filename)
      }
    })
  }
}
/**
 * 解析blob响应内容并下载
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
export function resolveBlob(res, mimeType, filename) {
  const aLink = document.createElement('a')
  let data = ''
  if (res.data) {
    data = res.data
  } else {
    data = res
  }
  var blob = new Blob([data], { type: mimeType })
  // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  var contentDisposition = decodeURI(res.headers['content-disposition'])
  var fileName = ''
  if (filename) {
    fileName = filename + new Date().getTime()
  } else {
    var result = patt.exec(contentDisposition)
    fileName = result[1]
    fileName = fileName.replace(/\"/g, '')
  }

  aLink.style.display = 'none'
  aLink.href = URL.createObjectURL(blob)
  aLink.setAttribute('download', fileName) // 设置下载文件名称
  document.body.appendChild(aLink)
  aLink.click()
  URL.revokeObjectURL(aLink.href) // 清除引用
  document.body.removeChild(aLink)
}
